import React from 'react';
import './Players.scss';
import { useSelector } from 'react-redux';
import { selectPlayers, selectMyPlayer } from '../../redux/gameSlice';
import Player from './Player';

export default function PlayerProfiles(props) {
    const players = useSelector(selectPlayers);
    const myPlayer = useSelector(selectMyPlayer);

    return <div id="players-container">
        {players.map(player => <Player key={player.id} player={player} isItMe={myPlayer.id === player.id} />)}
    </div>
}
